import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

const HTML = ({ id, tag, className, style, children, ...props }) => {
  const Tag = tag;
  return (
    <Tag
      id={id}
      className={cn(className, applyClasses(props, {}))}
      style={style}
      {...applyProps(props)}
    >
      {children}
    </Tag>
  );
};

HTML.propTypes = {
  /** The ID of the element. Useful to select the element during testing. */
  id: PropTypes.string,
  /** The HTML element tag */
  tag: PropTypes.string,
  /** A class name forwarded to the HTML element */
  className: PropTypes.string,
  /** A style object forwarded to the HTML element */
  style: PropTypes.object,
  /** The contents of the created element */
  children: PropTypes.any,
};

HTML.defaultProps = {
  tag: 'div',
  className: undefined,
  style: undefined,
  children: undefined,
};

export default HTML;
